// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__QK5Ft","header":"Messages_header__QTGZn"};